module.exports = __webpack_public_path__ + "static/tip_5-27a41247ab504495d5a9c0d6e7b800f9.jpg";